<template>
  <div class="w-full">
    <Head title="123" />
    <el-container class="h-full">
      <el-aside class="bg-gray-100" width="250px" style="height: 100%;">
        <app-menu :auth="auth" :forms="forms" :active-index="'flow_'+ action" />
      </el-aside>
      <el-main class="m-0 p-0 bg-white">
        <div class="h-full">
          <div
            v-loading="loading" class="body-content w-full h-full m-0"
            style="left: 0;"
          >
            <div class="fx-flow-manage-pane">
              <div class="fx-flow-list-toolbar">
                <div class="left">{{ title }}<span class="count-info">（共{{ total }}条）</span></div>
              </div>
              <div class="fx-flow-manage-list">
                <div v-if="list.length > 0" class="x-list list-view size-undefined">
                  <div
                    v-for="_item in list" :key="_item.id" class="fx-flow-item list-item todo"
                    @click="showDetail(_item.form_id, _item.id)"
                  >
                    <div class="batch-edit-container" />
                    <div class="creator-info">
                      <div
                        class="x-avatar creator-avatar color-1"
                        style="width: 40px; height: 40px; line-height: 40px; font-size: 20px;"
                      >
                        {{ _item.username.substr(0, 1) }}
                      </div>
                      <span class="name">{{ _item.username }}</span>
                    </div>
                    <div class="state-info">
                      <div class="entry-name">{{ _item.name }}</div>
                      <div v-if="_item.node_user" class="current-node">
                        审批人员：<span style="color:#000000;font-size: 13px;">{{ _item.node_user }}</span>
                      </div>
                      <div class="current-node">当前节点：{{ _item.node_name }}</div>
                    </div>
                    <ul class="flow-brief">
                      <li v-for="_data in _item.data" :key="_data.key" class="brief-item text-truncate">
                        <div class="brief-label">{{ _data.label }}</div>
                        <span class="sep">：</span>
                        <div class="brief-val">{{ _data.value }}</div>
                      </li>
                    </ul>
                    <div class="flow-time">{{ _item.create_time }}</div>
                  </div>
                  <pagination class="mt-6" :links="entries.links" />
                </div>
                <el-empty v-else description="暂无数据" />
              </div>
            </div>
          </div>
          <flow-detail v-if="dialogVisible" :visible.sync="dialogVisible" :query="detailQuery" />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>

import Pagination from '@/Shared/Pagination'
import zroute from '../../ziggy'
import AppMenu from '../../components/AppMenu'
import Layout from '@/Shared/Layout'
import FlowDetail from './FlowDetail'


export default {
  components: {
    FlowDetail,
    Pagination,
    AppMenu,
  },
  layout: Layout,
  props: {
    entries: {
      type: Object,
      default: () => ({}),
    },
    auth: {
      type: Object,
      default: () => ({}),
    },
    forms: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      app_id: zroute().params.app_id,
      action: zroute().params.action,
      detailQuery: {},
      loading: false,
      dialogVisible: false,
      total: this.entries.total ? this.entries.total : 0,
      list: this.entries.data,


    }
  },
  computed: {
    title() {
      var title = ''
      switch (this.action) {
      case 'todo':
        title = '我的待办'
        break
      case 'create':
        title = '我发起的'
        break
      case 'part':
        title = '我处理的'
        break
      }
      return title
    },
  },
  watch: {},
  created() {
    console.log('app flow created', this.app_id, this.action)

  },
  methods: {
    showDetail(form_id, entry_id) {
      this.detailQuery = {
        app_id: this.app_id,
        form_id: form_id,
        entry_id: entry_id,
        action: this.action,
      }
      this.dialogVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.body-content {
  background-color: #fff;

  .fx-flow-manage-pane {
    position: relative;
    height: 100%
  }

  .fx-flow-manage-pane .fx-flow-list-toolbar {
    height: 50px
  }

  .fx-flow-manage-pane .fx-flow-manage-list {
    position: absolute;
    top: 50px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden
  }

  .fx-flow-manage-pane .fx-flow-manage-list.batch-edit-mode {
    top: 55px;
    right: 15px;
    bottom: 15px;
    left: 15px;
    overflow: hidden;
    background: #fff;
    border-radius: 3px;
    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .1)
  }

  .fx-flow-list-toolbar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 0 20px;
    background: #fff;
    border-bottom: 1px solid #e2e2e2
  }

  .fx-flow-list-toolbar .left {
    font-weight: 700
  }

  .fx-flow-list-toolbar .left .count-info {
    padding-left: 2px;
    color: #f0ad4e;
    font-weight: 400
  }

  .fx-flow-list-toolbar .right,
  .fx-flow-list-toolbar .right .flow-btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  .fx-flow-list-toolbar .right .flow-btn {
    height: 26px;
    margin-left: 10px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 24px;
    border-radius: 3px;
    cursor: pointer
  }

  .fx-flow-list-toolbar .right .flow-btn .x-icon {
    padding-right: 3px;
    color: #5e6d82;
    font-size: 18px
  }

  .fx-flow-list-toolbar .right .flow-btn:hover {
    background: #f1f1f1
  }

  .fx-flow-list-toolbar .right .flow-btn.select {
    color: #0db3a6;
    background: #e6f7f6
  }

  .fx-flow-list-toolbar .right .flow-btn.select .x-icon {
    color: #0db3a6
  }

  .fx-flow-manage-list .flow-empty {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
  }

  .fx-flow-manage-list .list-view {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 15px 15px 10px;
    overflow: auto;
    border: none
  }

  .fx-flow-manage-list .list-view:hover {
    background: inherit
  }

  .fx-flow-manage-list .list-view .bottom-tip {
    height: 50px;
    color: #91a1b7;
    font-size: 12px;
    text-align: center;
    background: transparent
  }

  .fx-flow-manage-list .to-top {
    position: absolute;
    right: 15px;
    bottom: 63px;
    height: 40px;
    text-align: center;
    cursor: pointer
  }

  .fx-flow-manage-list .to-top .icon-to-top {
    color: rgba(0, 0, 0, .3);
    font-size: 40px
  }

  .fx-flow-manage-list .to-top .icon-to-top:hover {
    color: rgba(0, 0, 0, .6)
  }

  .fx-flow-manage-list.batch-edit-mode .batch-forward-toolbar {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    height: 50px;
    padding: 0 20px;
    border-bottom: 1px solid #e9e9e9
  }

  .fx-flow-manage-list.batch-edit-mode .batch-forward-toolbar,
  .fx-flow-manage-list.batch-edit-mode .batch-forward-toolbar .left {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  .fx-flow-manage-list.batch-edit-mode .batch-forward-toolbar .left .x-check {
    margin-right: 20px
  }

  .fx-flow-manage-list.batch-edit-mode .batch-forward-toolbar .left .check-info {
    color: #91a1b7
  }

  .fx-flow-manage-list.batch-edit-mode .batch-forward-toolbar .left .check-info .batch-count {
    color: #0db3a6
  }

  .fx-flow-manage-list.batch-edit-mode .batch-forward-toolbar .right {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  .fx-flow-manage-list.batch-edit-mode .batch-list {
    position: absolute;
    top: 50px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden
  }

  .fx-flow-manage-list.batch-edit-mode .batch-list .list-view {
    padding: 0
  }

  .fx-dash-calendar-content .calendar-data-list .x-list {
    border: none
  }

  .fx-dash-calendar-content .calendar-data-list .x-list .list-item {
    max-height: 47px;
    margin-bottom: 5px;
    padding: 5px;
    color: #1f2d3d;
    font-size: 12px;
    line-height: 14px;
    white-space: normal;
    cursor: pointer;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical
  }

  .fx-dash-calendar-content .calendar-data-list .x-list .list-item:hover {
    background: #e1e9f8
  }

  .fx-flow-item {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 88px;
    margin-bottom: 8px;
    padding: 8px 20px !important;
    background: #fff;
    border: 1px solid #e9e9e9;
    border-radius: 3px;
    -webkit-box-shadow: 0 0 8px 0 rgba(31, 45, 61, .08);
    box-shadow: 0 0 8px 0 rgba(31, 45, 61, .08);
    cursor: pointer;
    -webkit-transition: -webkit-box-shadow .2s ease-in-out;
    transition: -webkit-box-shadow .2s ease-in-out;
    transition: box-shadow .2s ease-in-out;
    transition: box-shadow .2s ease-in-out, -webkit-box-shadow .2s ease-in-out
  }

  .fx-flow-item:hover {
    background: #fff !important;
    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .1);
    box-shadow: 0 6px 12px rgba(0, 0, 0, .1)
  }

  .fx-flow-item.ccusers .state-info,
  .fx-flow-item.create .state-info,
  .fx-flow-item.transactors .state-info {
    padding: 0;
    font-size: 13px
  }

  .fx-flow-item.ccusers .state-info .flow-charge,
  .fx-flow-item.create .state-info .flow-charge,
  .fx-flow-item.transactors .state-info .flow-charge {
    margin: 4px 0;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }

  .fx-flow-item.ccusers .state-info .flow-charge .nodes,
  .fx-flow-item.create .state-info .flow-charge .nodes,
  .fx-flow-item.transactors .state-info .flow-charge .nodes {
    margin-right: 10px;
    color: #91a1b7
  }

  .fx-flow-item.ccusers .state-info .flow-state,
  .fx-flow-item.create .state-info .flow-state,
  .fx-flow-item.transactors .state-info .flow-state {
    display: inline-block;
    width: 70px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border-radius: 100px
  }

  .fx-flow-item.ccusers .state-info .flow-state.in-process,
  .fx-flow-item.create .state-info .flow-state.in-process,
  .fx-flow-item.transactors .state-info .flow-state.in-process {
    color: #248af9;
    background: #ebf5ff
  }

  .fx-flow-item.ccusers .state-info .flow-state.closed,
  .fx-flow-item.create .state-info .flow-state.closed,
  .fx-flow-item.transactors .state-info .flow-state.closed {
    color: #91a1b7;
    background: #f5f5f7
  }

  .fx-flow-item.ccusers .state-info .flow-state.complete,
  .fx-flow-item.create .state-info .flow-state.complete,
  .fx-flow-item.transactors .state-info .flow-state.complete {
    color: #0db3a6;
    background: #ebf8f7
  }

  .fx-flow-item.ccusers .state-info.node-empty,
  .fx-flow-item.create .state-info.node-empty,
  .fx-flow-item.transactors .state-info.node-empty {
    padding: 5px 0
  }

  .fx-flow-item.ccusers .state-info.node-empty .flow-charge,
  .fx-flow-item.create .state-info.node-empty .flow-charge,
  .fx-flow-item.transactors .state-info.node-empty .flow-charge {
    height: 16px;
    margin: 0
  }

  .fx-flow-item .creator-info {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: calc(15.5vw - 32px);
    min-width: 168px;
    max-width: 268px;
    line-height: 70px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }

  .fx-flow-item .creator-info .creator-avatar {
    margin: 0 10px 0 15px
  }

  .fx-flow-item .creator-info .creator-avatar .avatar-image {
    vertical-align: middle
  }

  .fx-flow-item .state-info {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: calc(34.4vw - 188px);
    min-width: 252px;
    max-width: 472px;
    padding: 5px 0
  }

  .fx-flow-item .state-info .entry-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    line-height: 22px
  }

  .fx-flow-item .state-info .current-node {
    color: #91a1b7;
    font-size: 13px;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }

  .fx-flow-item .flow-brief {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }

  .fx-flow-item .flow-brief .brief-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 24px;
    font-size: 13px;
    line-height: 22px
  }

  .fx-flow-item .flow-brief .brief-item .brief-label,
  .fx-flow-item .flow-brief .brief-item.text-truncate {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }

  .fx-flow-item .flow-brief .brief-item .brief-label {
    display: inline-block;
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    max-width: 100px;
    color: #91a1b7;
    vertical-align: top
  }

  .fx-flow-item .flow-brief .brief-item .sep {
    color: #91a1b7
  }

  .fx-flow-item .flow-brief .brief-item .brief-val {
    display: inline-block;
    -webkit-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }

  .fx-flow-item .flow-brief .brief-item .brief-val .tag-list {
    display: inline-block;
    width: 100%;
    overflow: hidden
  }

  .fx-flow-item .flow-brief .brief-item .brief-val .tag-list .fui-text-tag {
    margin-right: 4px
  }

  .fx-flow-item .flow-time {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: calc(18.7vw - 112px);
    min-width: 155px;
    max-width: 248px;
    padding-top: 4px;
    color: #91a1b7;
    font-size: 13px;
    text-align: right
  }

  .fx-flow-item .flow-hint {
    position: absolute;
    right: 0;
    bottom: 10px;
    height: 25px;
    padding: 0 7px;
    font-size: 12px;
    line-height: 27px;
    border-radius: 12.5px 0 0 12.5px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
  }

  .fx-flow-item .flow-hint.fail-hint {
    padding-right: 20px;
    color: #dc0f0f
  }

  .fx-flow-item .flow-hint.expire-time-hint {
    color: #248af9;
    background: #e9f3fe
  }

  .fx-flow-item .flow-hint.expire-time-hint.overtime {
    color: #f5a439;
    background: #fef2e2
  }

  .fx-flow-item .flow-hint.expire-time-hint.urged {
    color: #dc0f0f;
    background: #ffe7e4
  }

  .fx-flow-item .flow-hint.expire-time-hint .sep {
    margin: 0 8px
  }

  .fx-flow-item .flow-hint.expire-time-hint .time-icon {
    margin-right: 4px;
    font-size: 14px
  }

  .fx-flow-item.batch-edit {
    margin-bottom: 0;
    padding-left: 45px;
    -webkit-box-shadow: none;
    box-shadow: none
  }

  .fx-flow-item.batch-edit .batch-edit-container {
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 25px
  }

  .fx-flow-item.batch-edit .batch-edit-container .batch-edit-check {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0
  }

  .fx-flow-item.batch-edit .batch-edit-container .batch-edit-check .check-label {
    height: 100%;
    padding-left: 20px
  }

  .fx-flow-item.batch-edit:hover {
    background: #fafafa;
    -webkit-box-shadow: none;
    box-shadow: none;
    cursor: default
  }

  .fx-flow-item.batch-edit:before {
    position: absolute;
    right: 20px;
    bottom: 0;
    left: 20px;
    display: block;
    height: 1px;
    background: #e9e9e9;
    content: ""
  }

  .fx-flow-log-item .flow-log-content .flow-log-pane .flow-action .name {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }

  .x-avatar {
    display: inline-block;
    overflow: hidden;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    background: #248af9;
    border-radius: 50%
  }

  .x-avatar > img {
    width: 100%;
    height: 100%
  }

  .x-avatar.color-0 {
    background: #f5c547
  }

  .x-avatar.color-1 {
    background: #5d9cee
  }

  .x-avatar.color-2 {
    background: #4ec2e9
  }

  .x-avatar.color-3 {
    background: #52ce87
  }

  .x-avatar.color-4 {
    background: #ed5565
  }

  .x-avatar.color-5 {
    background: #978df1
  }

  .x-avatar.is-image-type {
    background: #fff
  }


}

.form-data-header {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50px;
  flex: 0 0 50px;
  width: 100%;
  height: 50px;
  padding: 0 10px 0 24px;
  color: #fff;
  background: #0db3a6
}

.form-data-header .header-title {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding-right: 20px;
  overflow: hidden;
  color: #fff;
  font-size: 16px;
  line-height: 50px;
  white-space: nowrap;
  text-align: left;
  text-overflow: ellipsis
}

.form-data-header .header-icon {
  width: 40px;
  min-width: 40px;
  height: 50px;
  font-size: 20px;
  line-height: 50px;
  text-align: center;
  cursor: pointer
}

.fx-flow-node-selector .node-text {
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-width: 600px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}

.fx-flow-node-selector .node-text .text-content {
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}
.el-main {
  padding: 0;
}

</style>
